/** Triangle pulse trace from the Defibrillator mark (icon.svg). */
export const PULSE_WAVE_PATH =
  "M0 120 H88 L128 0 L184 240 L224 80 L264 144 H320";

/** Single ECG beat for the static header lockup. */
export const BRAND_WAVE_PATH =
  "M0 140 H56 Q76 102 96 140 L112 158 L126 16 L142 214 L158 140 Q192 82 226 140 H320";

type BrandWaveProps = {
  className?: string;
};

/** Static brand ECG mark (header lockup). */
export function BrandWave({ className }: BrandWaveProps) {
  const classes = ["brand-wave", className].filter(Boolean).join(" ");

  return (
    <span className={classes} aria-hidden>
      <svg viewBox="0 0 320 240" preserveAspectRatio="none">
        <path
          d={BRAND_WAVE_PATH}
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="square"
          strokeLinejoin="miter"
          vectorEffect="non-scaling-stroke"
        />
      </svg>
    </span>
  );
}

type PulseWaveLoaderProps = {
  className?: string;
};

export function PulseWaveLoader({ className }: PulseWaveLoaderProps) {
  const classes = ["pulse-wave-loader", className].filter(Boolean).join(" ");

  return (
    <span className={classes} aria-hidden>
      <svg viewBox="0 0 640 240" preserveAspectRatio="none">
        <g className="pulse-wave-scroll">
          <path
            d={PULSE_WAVE_PATH}
            fill="none"
            stroke="currentColor"
            strokeWidth="28"
            strokeLinecap="square"
            strokeLinejoin="miter"
          />
          <path
            d={PULSE_WAVE_PATH}
            transform="translate(320 0)"
            fill="none"
            stroke="currentColor"
            strokeWidth="28"
            strokeLinecap="square"
            strokeLinejoin="miter"
          />
        </g>
      </svg>
    </span>
  );
}
